const ELECTRICITY_PREPAID_URL = '/electricities/prepaid-transactions';

/**
 * https://blueprint.bukalapak.io/t/electricity~prepaid~electricity~prepaid~transactions~get~electricities~prepaid-transactions~id
 * @param {object} param
 * @param {string} param.transactionId - transaction id of the electricity prepaid transaction
 * @returns {Promise}
 */
export const getElectricityPrepaidTransaction = ($axios, { transactionId = '' }) =>
  $axios.$get(`${ELECTRICITY_PREPAID_URL}/${transactionId}`);
